import React from "react";
import "../styles/privacy.css";

const Privacy = () => {
  return (
    <div className="privacy">
      <div className="privacy__container">
        <h1>Privacy Policy</h1>
        <p className="privacy__last-updated">Last Updated: 03/04/2025</p>
        <div className="privacy__content">
          <p className="privacy__intro">
            QRSharp ("we", "us", or "our") is committed to protecting your
            privacy. This Privacy Policy explains how we collect, use, and
            protect your personal information when you use our website
            (https://www.qrsharp.com) and services.
          </p>

          <section className="privacy__section">
            <h2>1. Information We Collect</h2>
            <p>When you create an account on QRSharp, we collect:</p>
            <ul>
              <li>Your email address</li>
              <li>
                Your password (securely hashed using Firebase Authentication)
              </li>
            </ul>
            <p>
              When using our service to create QR codes and view analytics, we
              do not log your IP address or use cookies to track activity.
              However, we do collect aggregate scanner analytics, including:
            </p>
            <ul>
              <li>Scanner count</li>
              <li>Country</li>
              <li>Browser</li>
              <li>Operating System</li>
            </ul>
            <p>
              We do not collect any personally identifiable information from QR
              code scanners.
            </p>
          </section>

          <section className="privacy__section">
            <h2>2. Use of Third-Party Services</h2>
            <p>We use the following third-party services to operate QRSharp:</p>
            <ul>
              <li>
                Firebase Authentication – to securely handle user login and
                password protection.
              </li>
              <li>
                Stripe – to process payments securely for premium features.
              </li>
              <li>
                Google Analytics – to help us understand how users interact with
                our platform and improve user experience.
              </li>
            </ul>
            <p>
              These third parties may collect data in accordance with their own
              privacy policies.
            </p>
          </section>

          <section className="privacy__section">
            <h2>3. Data Retention</h2>
            <p>
              We retain your account and associated QR code data for as long as
              your account is active. If you wish to delete your account and
              associated data, you may contact us at Support@QRSharp.com.
            </p>
          </section>

          <section className="privacy__section">
            <h2>4. Your Rights</h2>
            <p>
              As a UK-based company, we comply with the UK General Data
              Protection Regulation (GDPR). You have the right to:
            </p>
            <ul>
              <li>Access the data we hold about you</li>
              <li>Correct any inaccurate or incomplete information</li>
              <li>Request deletion of your data</li>
              <li>Withdraw consent for any processing of your data</li>
            </ul>
            <p>
              To exercise any of these rights, please contact us at
              Support@QRSharp.com.
            </p>
          </section>

          <section className="privacy__section">
            <h2>5. Security</h2>
            <p>
              We take your data seriously and implement appropriate security
              measures. Passwords are securely hashed, and data is transmitted
              over encrypted connections.
            </p>
          </section>

          <section className="privacy__section">
            <h2>6. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes
              will be posted on this page with an updated effective date.
              Continued use of our service constitutes acceptance of the revised
              policy.
            </p>
          </section>

          <section className="privacy__section">
            <h2>7. Contact Us</h2>
            <p>
              For any privacy-related concerns or questions, please reach out to
              us at:
            </p>
            <p className="privacy__contact">Support@QRSharp.com</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
